// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teams_wrapper__ns4i2 {
  display: grid;
}

.teams_content__HSxTL {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  height: min-content;
}

@media (max-width: 768px) {
  .teams_content__HSxTL {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/teams/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".wrapper {\n  display: grid;\n}\n\n.content {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n  height: min-content;\n}\n\n@media (max-width: 768px) {\n  .content {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `teams_wrapper__ns4i2`,
	"content": `teams_content__HSxTL`
};
export default ___CSS_LOADER_EXPORT___;
